<template>
  <div class="container">
    <div>
      <el-button type="text" @click="goback" size="mini" class="mb-2" icon="el-icon-arrow-left">返回</el-button>
    </div>
    <!--    <span v-if="inspect_status">-->
    <!--            <el-button size="mini" type="primary" @click="handleAdd">新增</el-button>-->
    <!--    </span>-->
    <el-table :data="tableData" :header-cell-style="{background:'#B4DDD1',color:'#555'}"
              style="width: 100%">
      <el-table-column prop="id" label="序号"></el-table-column>
      <!--      <el-table-column prop="project_name" label="项目名称"></el-table-column>-->
      <el-table-column prop="url" label="图片">
        <template v-slot="scope">
          <img :src="scope.row.url" width="70" height="70" @click="previewPic(scope.row)"/>
        </template>
      </el-table-column>
      <el-table-column prop="pic_desc" label="描述"></el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button size="mini" plain type="danger" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
                   :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
                   layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>


    <!--图片预览-->
    <el-dialog :visible.sync="pictureModel.dialogVisible" :modal="false" v-model="pictureModel" title="图片预览"
               width="50%">
      <img :src="pictureModel.previewpic" alt="" width="100%"/>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="pictureModel.dialogVisible = false">确定</el-button>
          </span>
    </el-dialog>
    <!--编辑图片-->
    <el-dialog :visible.sync="editModel.show" title="编辑" width="50%" @click="onEditClose">
      <el-form v-model="editModel">
        <el-form-item label="图片描述">
          <el-input v-model="editModel.pic_des"></el-input>
        </el-form-item>
        <el-form-item label="是否放入报告">
          <el-select v-model="editModel.is_report">
            <el-option value="是" label="是"></el-option>
            <el-option value="否" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left:200px;margin-top: 30px">
          <el-button type="primary" @click="onEdit">修改</el-button>
          <el-button type="info" @click="onEditClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      loading: false,
      project_id: '',
      site_id: '',
      site_type: '',
      route_name: '',
      inspect_status: false,
      pages: [],
      currentPage: 1,
      pagination: {current_page: 1, total: 1, per_page: 10,},
      tableData: [],
      pictureModel: {
        dialogVisible: false,
        previewpic: '',
      },
      addModel: {
        show: false,
        file_id: '',
        pic_desc: ''
      },
      editModel: {
        show: false,
        id: '',
        pic_des: '',
        is_report: ''
      }
    }
  },
  methods: {
    handleAdd() {
      this.addModel.show = true
    },
    async onAdd() {
      try {
        await this.$Api.post('doc', {
          project_id: this.project_id,
          site_id: this.site_type,
          file_id: this.addModel.file_id,
          pic_desc: this.addModel.pic_desc
        })
        this.$message.success('操作成功')
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //设置操作按钮的状态
    async setButtonStatus() {
      try {
        let res = await this.$Api.post('get_site_status', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
          status_type: 'zg'
        })
        if (res) {
          if (res === '检测中') {
            this.inspect_status = true
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    goback() {
      this.$router.push({name: this.route_name, params: this.$route.params})
    },
    //预览图片
    previewPic(row) {
      this.pictureModel.previewpic = row.url
      this.pictureModel.dialogVisible = true
    },
    //初始化对话框
    initModel(model) {
      Object.keys(model).forEach(key => {
        if (key === 'show') {
          model[key] = false
        } else {
          model[key] = ''
        }
      })
    },
    //获取列表数据
    async getList() {
      try {
        this.loading = true;
        let params = {
          ...this.query,
          ...this.pagination,
        };
        params.project_id = this.project_id
        params.site_id = this.site_id
        let data = await this.$Api.get("docs", {params: params});
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //编辑
    async handleEdit(row) {
      this.editModel.show = true
      this.editModel.id = row.id
      this.editModel.pic_des = row.pic_desc
      this.editModel.is_report = row.is_report
    },
    async onEdit() {
      try {
        await this.$Api.post('edit_zg_image', {
          id: this.editModel.id,
          pic_desc: this.editModel.pic_des,
          is_report: this.editModel.is_report
        })
        await this.getList()
        this.$message.success('修改成功')
        this.initModel(this.editModel)
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onEditClose() {
      this.initModel(this.editModel)
    },
    //删除
    handleDel(row) {
      this.$confirm('确认删除?', '确认删除', {
        confirmButtonClass: '确认',
        cancelButtonClass: '取消',
        type: 'warning'
      }).then(
          async () => {
            try {
              await this.$Api.post('del_doc', {
                id: row.id
              })
              this.$message.success('删除成功')
              await this.getList()
            } catch (e) {
              this.$message.error(e.errormsg)
            }
          }
      )
    },
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.query = {
        project_code: "",
        project_name: "",
        status_id: "",
      };
      this.pagination.current_page = 1;
      this.pagination.total = 1;
      this.getList();
    },

  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.setButtonStatus()
    this.getList()
    switch (this.$route.params.site_type) {
      case 'czw':
        this.route_name = 'site_czw_list'
        break
      case 'sx':
        this.route_name = 'site_sx_list'
        break
      case 'other':
        this.route_name = 'site_other_list'
        break
    }
  }
}
</script>
<style scoped>

table {
  width: 100%;
}

#part1 {
  width: 600px;
  height: 600px;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  vertical-align: middle !important;
}
</style>
